/*
 * Product Row sticky header offset — singleton global publisher.
 * Loaded only when a Product Row section uses sticky_text_left or sticky_text_right layout.
 * Publishes --sticky-header-offset on document.documentElement, reflecting the visible
 * portion of the header so the sticky text column sits below the revealed header on
 * scroll-up. Idempotent via [data-sticky-header-offset-init] on <html>.
 * Hooks: [data-header] (height), [data-header-group] [data-header-sticky] (observed).
 */
(function () {
  'use strict';

  if (document.documentElement.dataset.stickyHeaderOffsetInit === 'true') return;

  const header = document.querySelector('[data-header]');
  if (!header) return;
  // Sticky state lives on the header GROUP (bar + header), not [data-header].
  const group = document.querySelector('[data-header-group]') || header;

  document.documentElement.dataset.stickyHeaderOffsetInit = 'true';

  function updateOffset() {
    const isVisible = group.dataset.headerSticky === 'visible';
    document.documentElement.style.setProperty(
      '--sticky-header-offset',
      isVisible ? header.offsetHeight + 'px' : '0px'
    );
  }

  updateOffset();

  new MutationObserver(updateOffset).observe(group, {
    attributes: true,
    attributeFilter: ['data-header-sticky'],
  });

  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(updateOffset).observe(header);
  }
})();
